export function initStoragesBlocks() {
    const blocks = [...document.querySelectorAll('[data-block="Storages"]')];
    blocks.forEach(initStoragesBlockInstance);
}

export function initStoragesBlockInstance(root) {
    const maps = [...root.querySelectorAll('.-map')];
    maps.forEach(initStorageMapInstance);
}

export function initStorageMapInstance(root) {
    const lat = root.dataset.lat;
    const lng = root.dataset.lng;
    const map = L.map(root, {
        center: [lat, lng],
        zoom: 13,
        zoomControl: false,
        attributionControl: false,
    });

    L.tileLayer(`https://api.mapbox.com/styles/v1/westart/{styleId}/tiles/256/{z}/{x}/{y}?access_token={accessToken}`, {
        attribution: '',
        accessToken: process.env.MIX_MAPBOX_TOKEN,
        styleId: process.env.MIX_MAPBOX_STYLE,
    }).addTo(map);

    map.dragging.disable();
    map.touchZoom.disable();
    map.doubleClickZoom.disable();
    map.scrollWheelZoom.disable();

    const mapMarker = L.divIcon({
        className: 'leaflet-marker',
        iconSize: [8, 4],
    });

    const marker = L.marker([lat, lng], {
        interactive: false,
        icon: mapMarker,
    }).addTo(map);
}
